import {NgModule} from '@angular/core';
import {CoreModule} from '../core/core.module';
import {DienstPipe} from './dienst.pipe';
import {DienstenPipe} from './diensten.pipe';
import {CategorieNavigationComponent} from './categorie-navigation/categorie-navigation.component';
import {DienstenNavigationComponent} from './diensten-navigation/diensten-navigation.component';
import {ZoneModule} from '../zone/zone.module';

@NgModule({
  declarations: [
    DienstPipe,
    DienstenPipe,
    CategorieNavigationComponent,
    DienstenNavigationComponent,
  ],
  imports: [
    CoreModule,
    ZoneModule,
  ],
  exports: [
    DienstPipe,
    DienstenPipe,
    CategorieNavigationComponent,
    DienstenNavigationComponent,
  ],
  providers: [
    DienstPipe,
    DienstenPipe,
  ],
})
export class DienstModule {
}
